import { trackEvent } from "../../../Actions/Utils";
const SpeakerChatBlock = ({idx, title, options, isPlaying, startAudio = () => { }, stopAudio = () => { }, setSpeakerOpen, speakerOpen}) => {

    const handleAudioStart = () => {
        trackEvent("narration_clicked", "Click", "Number of times user clicked on speaker/narration button (listen to answers)");
        startAudio(idx, title, options);
        setSpeakerOpen(!speakerOpen);
    }
    const handleAudioStop = () => {
        stopAudio();
        setSpeakerOpen(!speakerOpen);
    }
    
    return (
        <div id={`tour-speaker-chat-block-${idx}`} className="tour-speaker-block">
            {!isPlaying && <div className='rounded-full bg-[var(--neutral-white)] flex items-center justify-center p-2' onClick={handleAudioStart}>
                <img src={'./Assets/Images/graySpeaker.svg'} alt="speaker" />
            </div>}
            {isPlaying && <div className='rounded-full bg-[var(--primary-dark)] flex items-center justify-center p-2' onClick={handleAudioStop}>
            <img src={'./Assets/Images/whiteSpeaker.svg'} alt="speaker" />
            </div>}
        </div>
    )
}

export default SpeakerChatBlock;